import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {}

const updateRoster = (rosterDatas = [], newData = {}) => {
      if (newData.userId === rosterDatas.userId) {
        return {
          ...rosterDatas,
          ...newData
        }
      }
      return rosterDatas
    
}

const vCardData = createSlice({
    name:'vCardData',
    initialState,
    reducers:{
        addVCardData: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        },
        vcardUpdate: (_state,payload)=>{
            const rosterDetails = updateRoster(JSON.parse(JSON.stringify(_state)).data, payload.payload)
            return {
                ..._state,
             data: rosterDetails
        }
     }
    }
});

export default vCardData.reducer
export const addVCardData = vCardData.actions.addVCardData  
export const vcardUpdate = vCardData.actions.vcardUpdate
